import { sequireClient } from "./clients";

export function signup(payload)          { return sequireClient.post("/auth/signup", payload); }
export function login(payload)           { return sequireClient.post("/auth/login", payload); }
export function forgotPassword(email)    { return sequireClient.post("/auth/forgot-password", { email }); }
export function resetPassword(payload)   { return sequireClient.post("/auth/reset-password", payload); }
export function getFilings()             { return sequireClient.get("/filings"); }
export function validateCik(cik, entityType) {
  const params = entityType && entityType !== "company" ? { entity_type: entityType } : {};
  return sequireClient.get(`/companies/validate-cik/${cik}`, { params });
}
export function lookupByTicker(ticker)   { return sequireClient.get(`/companies/lookup-ticker/${ticker}`); }
export function updateCompanyCik(cik)    { return sequireClient.patch("/users/me/company", { cik }); }
export function updateProfile(payload)   { return sequireClient.patch("/users/me", payload); }
export function refreshToken(token)      { return sequireClient.post("/auth/refresh", { refresh_token: token }); }
